import { BodyText, Link } from '@farol-ds/react'

import { HELP_CENTER_URL, ROUTES } from '../../constants'
import { LoginCard } from '../login-card'
import styles from './email-password-reset.module.scss'

interface EmailPasswordResetProps {
  onCloseClick?: () => void
  onResendClick?: () => void
}

export function EmailPasswordReset({ onCloseClick, onResendClick }: EmailPasswordResetProps) {
  const header = {
    title: 'Verifique seu e-mail',
    subtitle: {
      content: (
        <>
          Caso exista uma conta associada ao e-mail informado, você receberá instruções para
          redefinir sua senha em alguns minutos.
        </>
      ),
    },
  }
  return (
    <LoginCard header={header} onCloseClick={onCloseClick}>
      <div className={styles.content}>
        <BodyText className={styles.bodyText}>
          Se não encontrar o e-mail na sua caixa de entrada, verifique a pasta de spam ou tente{' '}
          {onResendClick ? (
            <button type="button" onClick={onResendClick} className={styles.linkButton}>
              reenviar sua solicitação.
            </button>
          ) : (
            <Link href={ROUTES.PASSWORD_RECOVERY.BEGIN} className={styles.link}>
              reenviar sua solicitação.
            </Link>
          )}
          {'\n\n'}
          Se o problema persistir entre em contato com a gente através do nosso{' '}
          <Link href={HELP_CENTER_URL} className={styles.link} target="_blank">
            Suporte ao Usuário.
          </Link>
        </BodyText>
      </div>
    </LoginCard>
  )
}
